"use client";

import { Star, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const trustBadges = [];
  return <section data-section-id="253426" id="sezione-hero-visti-per-gruppi" className="relative flex min-h-[100svh] items-center overflow-hidden bg-background pt-20 lg:pt-0">
      {}
      <div className="absolute inset-0 z-0 lg:hidden">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_mobile.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_mobile.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_mobile.png-wvc-sizes" alt="Studenti in viaggio d'istruzione" className="h-full w-full object-cover opacity-20" loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/90 to-background" />
      </div>

      {}
      <div className="absolute inset-y-0 right-0 z-0 hidden w-[60%] lg:block border-l-4 border-secondary" style={{
      clipPath: "polygon(15% 0, 100% 0, 100% 100%, 0 100%)"
    }}>
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_desktop.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_desktop.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/visti_gruppi_scolastici_desktop.png-wvc-sizes" alt="Gruppo di studenti internazionali" className="h-full w-full object-cover" loading="eager" />
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/90 to-primary/60 backdrop-blur-[2px] mix-blend-multiply" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:w-[55%] lg:pr-12 xl:pr-20">
          {}
          <div className="mb-8 flex flex-wrap items-center gap-6 md:gap-10">
            {trustBadges.map((badge, i) => <div key={i} data-index={i} className="flex flex-col gap-1.5">
                <div className="flex gap-0.5 text-secondary">
                  {[...Array(5)].map((_, j) => <Star key={j} data-index={j} className="size-4 fill-current md:size-5" />)}
                </div>
                <span className="text-[10px] font-default font-bold uppercase tracking-wider text-muted-foreground md:text-xs">
                  {badge.platform}
                </span>
              </div>)}
          </div>

          {}
          <h1 className="mb-6 font-default text-5xl font-bold leading-[1.1] tracking-tight text-foreground md:text-6xl lg:text-7xl">
            Visti per Gruppi e <br className="hidden md:block" />
            Gite Scolastiche
          </h1>

          {}
          <p className="mb-10 max-w-lg text-lg font-default text-muted-foreground md:text-xl">
            Supporto istituzionale completo per scuole e organizzazioni. Gestiamo ogni pratica burocratica per garantire viaggi d'istruzione sicuri e senza intoppi.
          </p>

          {}
          <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
            <Button asChild size="lg" className="group h-14 bg-[#FFC829] px-8 text-base font-default font-bold uppercase tracking-wide text-primary transition-all duration-300 hover:bg-[#FFC829]/90 hover:shadow-lg hover:shadow-secondary/20 rounded-md">
              <Link to="/ContactsPage">
                Richiedi un Preventivo
                <ArrowUpRight className="ml-2 size-5 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-14 px-8 text-base font-default font-semibold transition-all duration-300 border-[#FFC829] text-[#FFC829] hover:bg-accent hover:text-accent-foreground rounded-md">
              <Link to="/StudentsAndInstitutesPage">Servizi Istituti</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}